class ConfirmDialog {
  constructor() {
    Turbo.config.forms.confirm = this.confirmMethod.bind(this);
  }

  confirmMethod(message, element) {
    const dialog = this.insertConfirmModal(message, element);
    dialog.showModal();

    return new Promise((resolve) => {
      dialog.querySelectorAll("[data-behavior='cancel']").forEach((cancelButton) => {
        cancelButton.addEventListener("click", () => {
          dialog.remove();
          resolve(false);
        }, { once: true });
      })

      dialog.querySelector("[data-behavior='commit']").addEventListener("click", () => {
        dialog.remove();
        resolve(true);
      }, { once: true });
    });
  }

  insertConfirmModal(message, element) {
    const dialogId = "custom-confirm-dialog";
    const commitLabel = document.querySelector('meta[name="confirm-dialog-commit"]')?.content || 'Confirmă';
    const cancelLabel = document.querySelector('meta[name="confirm-dialog-cancel"]')?.content || 'Anulează';

    const content = `
      <dialog class="dialog" id="${dialogId}" role="alertdialog" aria-labelledby="dialog_label" aria-describedby="dialog_desc">
        <button type="button" class="btn btn--sm btn--circle btn--ghost dialog__close" data-behavior="cancel" aria-label="Close dialog">
          <i class="icon-x pointer-events-none"></i>
        </button>
        <div class="dialog__content">
          <p class="text-sm text-subtle mbe-4" id="dialog_desc"></p>
          <div class="flex justify-between">
            <div class="flex items-center gap">
              <button type="button" class="btn btn--primary" data-behavior="commit">${commitLabel}</button>
              <button type="button" class="btn" data-behavior="cancel" autofocus>${cancelLabel}</button>
            </div>
          </div>
        </div>
      </dialog>
    `;

    document.body.insertAdjacentHTML('beforeend', content);
    
    const dialog = document.getElementById(dialogId);
    dialog.querySelector('#dialog_desc').textContent = message;
    
    document.activeElement.blur();

    return dialog;
  }
}

export default ConfirmDialog;